module.exports = "<img [src]=\"imgUrl\" class=\"logo\" />\n"


//////////////////
// WEBPACK FOOTER
// ./src/viega-common/components/viega-logo/viega-logo.component.html
// module id = C6OE
// module chunks = 5